import { createBrowserRouter, RouterProvider } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import "./App.css";
import { Blogs } from "./pages/Blogs";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/Admin";
import Services from "./pages/Services";
// import Insurance from './pages/Insurance'
// import Portfolio from "./pages/Portfolio";
// import OnlineTrading from "./pages/OnlineTrading";
// import FD from "./pages/FD";
// import Loan from "./pages/Loan";
// import MutualFund from "./pages/MutualFund";
import ComingSoon from "./pages/ComingSoon";
import AdminUploads from "./pages/AdminUploads";
import AddBlogPage from "./pages/AddBlogPage";
import ViewBlogsPage from "./pages/ViewBlogsPage";
import BlogDetail from "./pages/BlogDetail";
import ErrorPage from "./pages/ErrorPage";

const router = createBrowserRouter([
  {
    path: "/adminlogin",
    element: <AdminLogin />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/admin",
    element: <AdminDashboard />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/adminupload",
    element: <AdminUploads />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/add",
    element: <AddBlogPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/adminView",
    element: <ViewBlogsPage />,
    errorElement: <ErrorPage />,
  },
    {
    path: "/blog/:id",   // ✅ dynamic route
    element: <BlogDetail />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/about", element: <About /> },
      { path: "/contact", element: <Contact /> },
      { path: "/blog", element: <Blogs /> },
      { path: "/services", element: <Services /> },
      { path: "/insurance", element: <ComingSoon /> },
      { path: "/mutualfunds", element: <ComingSoon /> },
      { path: "/portfolio", element: <ComingSoon /> },
      { path: "/onlinetrading", element: <ComingSoon /> },
      { path: "/fd", element: <ComingSoon /> },
      { path: "/loans", element: <ComingSoon /> },
      { path: "/aif", element: <ComingSoon /> },
      { path: "/sif", element: <ComingSoon /> },
      { path: "*", element: <ErrorPage /> },
    ],
  },
  { path: "*", element: <ErrorPage /> },
]);

const App = () => <RouterProvider router={router} />;

export default App;
